<form [formGroup]="formGroup">
  <div class="d-flex flex-column gap-4">
    <div class="form-container">
      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" [for]="'firstName'" i18n>First Name</label>
        <app-text-input
          [error]="formGroup?.controls?.firstName?.invalid && formSubmitted"
          formControlName="firstName"
          controlId="firstName" />
        <app-form-error
          *ngIf="formSubmitted && formGroup?.controls?.firstName?.invalid"
          [errors]="formGroup?.controls?.firstName?.errors" />
      </div>
      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" [for]="'middleName'" i18n>Middle Name</label>
        <app-text-input formControlName="middleName" controlId="middleName" />
        <small class="hint" i18n>Optional</small>
      </div>

      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" [for]="'lastName'" i18n>Last Name</label>
        <app-text-input
          [error]="formGroup?.controls?.lastName?.invalid && formSubmitted"
          formControlName="lastName"
          controlId="lastName" />
        <app-form-error
          *ngIf="formSubmitted && formGroup?.controls?.lastName?.invalid"
          [errors]="formGroup?.controls?.lastName?.errors" />
      </div>
      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" [for]="'sin'" i18n>Social Insurance Number</label>
        <app-sin-input
          [error]="formGroup?.controls?.sin?.invalid && formSubmitted"
          formControlName="sin"
          controlId="sin" />
        <app-form-error
          *ngIf="formSubmitted && formGroup?.controls?.sin?.invalid"
          [errors]="formGroup?.controls?.sin?.errors" />
        <small class="hint" i18n>Optional</small>
      </div>
      <div class="d-flex flex-column gap-1">
        <label class="form-input-label" [for]="'dateOfBirth'" i18n>Date of Birth</label>
        <app-datepicker-input
          [error]="formGroup?.controls?.dateOfBirth?.invalid && formSubmitted"
          formControlName="dateOfBirth"
          controlId="dateOfBirth" />
        <app-form-error
          *ngIf="formSubmitted && formGroup?.controls?.dateOfBirth?.invalid"
          [errors]="formGroup?.controls?.dateOfBirth?.errors" />
      </div>
    </div>
  </div>
</form>
